import Census from "../census/census";

export default class CensusFast extends Census {
	constructor($el) {
		super($el, {
			classname: "c-census-fast-container",
			action: "hb_censuses_fast_create_ajax",
		});
	}
}

